document.querySelectorAll('.tpt-get-started .select__select').forEach((select) => {
	const update = () => {
		select.classList.toggle('is-empty', !select.value);
	};

	select.addEventListener('change', update);
	update();
});

if (!customElements.get('tpt-deposit-item')) {
	customElements.define(
		'tpt-deposit-item',
		class TptDepositItem extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.activeTabForm.bind(this));
			}

			activeTabForm() {
				const formTarget = this.getAttribute('data-target');

				document.querySelectorAll('.tpt-deposit-product__variant, .tpt-deposit-product__variant-form').forEach((tabItem) => {
					tabItem.classList.remove('active');
				});

				this.classList.add('active');
				document.getElementById(formTarget).classList.add('active');
			}
		},
	);
}

if (!customElements.get('tpt-get-started-trigger')) {
	customElements.define(
		'tpt-get-started-trigger',
		class TptGetStarted extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('click', this.startedTrigger.bind(this));
			}

			getFieldLabel(input) {
				const name = input.name || '';

				const match = name.match(/\[(.*?)\]/);

				if (match) {
					return match[1];
				}

				return input.placeholder || 'Field';
			}

			validateCurrentStep() {
				const currentStep = this.closest('form');

				if (!currentStep) return true;

				const errorContainer = currentStep.querySelector('.tpt-measurement-form__error');

				const requiredInputs = currentStep.querySelectorAll('input[required], textarea[required], select[required]');

				let isValid = true;
				let firstError = null;
				const errors = [];

				if (errorContainer) {
					errorContainer.innerHTML = '';
					errorContainer.classList.remove('active');
				}

				requiredInputs.forEach((input) => {
					input.classList.remove('error');

					const label = this.getFieldLabel(input);

					// Required validation
					if (!input.value.trim()) {
						isValid = false;

						input.classList.add('error');

						errors.push(`${label} is required.`);

						if (!firstError) firstError = input;

						return;
					}

					// Email validation
					if (input.type === 'email' && !input.validity.valid) {
						isValid = false;

						input.classList.add('error');

						errors.push(`${label} is invalid.`);

						if (!firstError) firstError = input;
					}

					// Phone validation
					if (input.classList.contains('tpt-field-phone')) {
						const normalizedPhone = input.value.replace(/[^\d+]/g, '');

						const phoneRegex = /^\+[1-9]\d{1,14}$/;

						if (!phoneRegex.test(normalizedPhone)) {
							isValid = false;

							input.classList.add('error');

							errors.push(`${label} must be a valid international phone number (example: +84912345678).`);

							if (!firstError) firstError = input;
						}
					}
				});

				if (!isValid) {
					if (errorContainer) {
						errorContainer.innerHTML = `
							<ul>
								${errors.map((error) => `<li>${error}</li>`).join('')}
							</ul>
						`;

						errorContainer.classList.add('active');
					}

					firstError?.focus({
						preventScroll: false,
					});
				}

				return isValid;
			}

			startedTrigger() {
				const isValid = this.validateCurrentStep();

				console.log(isValid);

				if (!isValid) return;

				const btnAddCart = this.closest('.tpt-get-started__submit').querySelector('button');
				btnAddCart.click();
			}
		},
	);
}
